import React, { useState } from "react";
import "./OpenPositions.css";
import JobDetailsModal from "./JobDetailsModal";

const OpenPositions = () => {
  const [selectedJob, setSelectedJob] = useState(null);

  const positions = [
    {
      title: "Dot Net Internship",
      description:
        "We Provide Remote paid Internship at Quad Theory Ltd lasts 3 months.",
      tags: ["Remotely", "Internship", "paid", "Exp. 1-2 years"],
      location: "Work from home",
      position: "Dot Net Intern",
      duration: "3 months",
      skills: [
        "Practical knowledge in C#, .NET, MVC, Entity framework, SQL, HTML, CSS, Bootstrap, and React.js.",
        "Should have knowledge of the MVC framework.",
        "Must have knowledge of OOP concepts.",
        "Problem-solver and team player.",
        "Proactive, quick learner, and energetic.",
      ],
      email: "hr@quadtheoryltd.com",
      subjectLine: "QT_DOTNET_I_02023",
    },
    {
      title: "Dot NET Software Developer",
      description:
        "We Provide Remote NET Software Developer Position. we need Exp. 5 Years.",
      tags: ["Remotely", "Net Developer", "Competitive", "Exp. 1-3 years"],
      location: "Work from home",
      position: "Dot NET Software Developer",
      duration: "Permanent",
      skills: [
        "5+ years experience in .NET development.",
        "Strong understanding of ASP.NET Core, Web API, and Microservices.",
        "Proficient in SQL Server and ORM tools like Entity Framework.",
        "Experience with cloud platforms (Azure preferred).",
        "Excellent problem-solving skills and ability to work in agile teams.",
      ],
      email: "hr@quadtheoryltd.com",
      subjectLine: "QT_DOTNET_DEV_02023",
    },
  ];

  const handleCardClick = (job) => {
    setSelectedJob(job);
  };

  const closeModal = () => {
    setSelectedJob(null);
  };

  return (
    <div id="open-positions" className="open-positions-container">
      <h1 className="page-title">Available Opportunities</h1>
      <div className="positions-grid">
        {positions.map((position, index) => (
          <div
            key={index}
            className="open-position-card"
            onClick={() => handleCardClick(position)}
          >
            <div className="position-tags">
              {position.tags.map((tag, tagIndex) => (
                <span key={tagIndex} className="tag">
                  {tag}
                </span>
              ))}
            </div>
            <h3 className="position-title">{position.title}</h3>
            <p className="position-description">{position.description}</p>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedJob && (
        <JobDetailsModal job={selectedJob} onClose={closeModal} />
      )}
    </div>
  );
};

export default OpenPositions;
